// extracted by mini-css-extract-plugin
export default {"floatingVideo":"floating-remote-video_floatingVideo__eBCWo"};